// Status is a "state machine"
export const Status = {
  // UNINITIALIZED -> PENDING
  UNINITIALIZED: 'UNINITIALIZED',
  // PENDING -> SUCCEEDED, ERRORED, CANCELED
  PENDING: 'PENDING',
  // SUCCEEDED -> PENDING
  SUCCEEDED: 'SUCCEEDED',
  // ERRORED -> PENDING
  ERRORED: 'ERRORED',
  // CANCELED -> PENDING
  CANCELED: 'CANCELED'
};
const isSettled = status => status === Status.SUCCEEDED || status === Status.ERRORED;
export const mergeAsyncState = asyncStates => {
  const settled = asyncStates.map(state => state.status).every(isSettled);
  const loading = asyncStates.map(state => state.status).some(status => status === Status.PENDING);
  const error = asyncStates.map(state => state.error).find(e => !!e);
  return {
    settled,
    loading,
    error
  };
};